// 个人资料 Modal 状态管理
import { defineStore } from 'pinia'

export const useMyProfileStore = defineStore('myProfileStore', () => {
  const isOpenMyProfileModal = ref(false)
  const openMyProfileModal = () => {
    isOpenMyProfileModal.value = true
  }
  const closeMyProfileModal = () => {
    isOpenMyProfileModal.value = false
  }

  return {
    isOpenMyProfileModal,
    openMyProfileModal,
    closeMyProfileModal
  }
})
